import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Checkbox,
} from '../index';
import { Caller } from './Caller';
import { getTenantCheckboxState } from './helper';

export const Tenant = ({
  tenantID,
  tenantName,
  tenantTeam,
  filteredTeam,
  selectedCallerIds,
  handleTenant,
  handleCaller,
}) => {
  const hasTeam = filteredTeam.length > 0;
  const { indeterminate, checked } = getTenantCheckboxState(
    tenantID,
    tenantTeam,
    selectedCallerIds,
  );

  return (
    <Accordion>
      <div className="flex items-center justify-between gap-2 pl-1 pr-3">
        <label className="flex items-center gap-2 pl-1 py-1.5 cursor-pointer w-full rounded-lg hover:bg-brand-300/[0.08] truncate">
          <Checkbox
            indeterminate={indeterminate}
            checked={checked}
            onChange={handleTenant}
          />
          <span className="text-[16px]/[24px] text-base-1000 font-medium truncate">
            {tenantName}
          </span>
        </label>
        {hasTeam && <AccordionSummary />}
      </div>
      {hasTeam && (
        <AccordionDetails>
          <div className="flex flex-col gap-1 p-1">
            {filteredTeam.map(caller => {
              const { CallerID, CallerName } = caller;
              const checked = !!selectedCallerIds.find(
                ({ TenantID, CallerID }) =>
                  TenantID === caller.TenantID && CallerID === caller.CallerID,
              );

              return (
                <Caller
                  key={CallerID}
                  callerName={CallerName}
                  checked={checked}
                  onChange={() => {
                    handleCaller(caller);
                  }}
                />
              );
            })}
          </div>
        </AccordionDetails>
      )}
    </Accordion>
  );
};
